// extracted by mini-css-extract-plugin
module.exports = {"w82zs5x":"w82zs5x","s1pvjviy":"s1pvjviy","h1indsjw":"h1indsjw"};